import {CONTAINER_ITEM_MENU_ITEMS} from '../../containers/item-context-menu';
import {FavoriteType} from '../../favorites/favorites.service';
import {SmContextMenuItemModel} from '../components/sm-context-menu-item/sm-context-menu-item.component';
import {PRODUCT_CONTAINER_MENU_ITEMS} from './product-context-menu';

/** All inventory surfaces share ordering, labels and permission filtering. */
export function buildInventoryMenu(
  type: FavoriteType,
  favorite: SmContextMenuItemModel,
  canEdit: boolean,
): SmContextMenuItemModel[] {
  const basketAction = CONTAINER_ITEM_MENU_ITEMS.find(action => action.id === 'add-to-basket');
  if (!canEdit) return type === 'item' && basketAction ? [favorite, basketAction] : [favorite];
  const actions = type === 'item' ? CONTAINER_ITEM_MENU_ITEMS : PRODUCT_CONTAINER_MENU_ITEMS;
  return [favorite, ...actions];
}
